import { render } from "./BacktestPeriod.vue?vue&type=template&id=05f69c38&scoped=true&ts=true"
import script from "./BacktestPeriod.vue?vue&type=script&lang=ts"
export * from "./BacktestPeriod.vue?vue&type=script&lang=ts"

import "./BacktestPeriod.vue?vue&type=style&index=0&id=05f69c38&scoped=true&lang=less"

import exportComponent from "E:\\operationmanualNew\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05f69c38"]])

export default __exports__